"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeOrderState = void 0;
const events_1 = __importDefault(require("./events"));
const updateOccupiedTableStatus_1 = require("./updateOccupiedTableStatus");
const orderEventsSorting_1 = require("./orderEventsSorting");
/**
 * Accepts a sorted list of events and order state to compute next order state
 * @param events
 * @param prevState
 */
function computeOrderState(events, prevState = {}) {
    const sorted = (0, orderEventsSorting_1.sortEventsByTimeStamp)((0, orderEventsSorting_1.dedupeOrderEvents)(events));
    return sorted.reduce((state, event) => {
        const computeNextOrderState = events_1.default[event.action];
        if (typeof computeNextOrderState === 'function') {
            const order = (0, updateOccupiedTableStatus_1.updateOccupiedTableStatus)(event, computeNextOrderState(event, state));
            order.prevEventId = event.id;
            order.updatedAt = event.timestamp;
            order.eventsCount = (order.eventsCount || 0) + 1;
            if (event.triggeredBy)
                order.updatedBy = { id: event.triggeredBy };
            if (event.deviceId)
                order.updatedByDevice = { id: event.deviceId };
            return order;
        }
        else {
            throw new Error(`handler not defined for order action: ${event.action}`);
        }
    }, prevState);
}
exports.computeOrderState = computeOrderState;
//# sourceMappingURL=computeOrderState.js.map